import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import router from '@/router'

const addErrorLog = errorInfo => {
    const { statusText, status, request: { responseURL } } = errorInfo;
    let info = {
        type: 'ajax',
        code: status,
        mes: statusText,
        url: responseURL
    };
    if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
};

class HttpRequest {
    constructor (baseUrl) {
        this.baseUrl = baseUrl;
        this.queue = {}
    }
    getInsideConfig () {
        let token = store.state.user.token;
        let uid = store.state.user.userId;
        const config = {
            baseURL: this.baseUrl,
            headers: {
                'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
            },
        };

        if(token && token!=='undefined'){
            config.headers.token = token;
        }
        if(uid && uid!=='undefined'){
            config.headers.uid = uid;
        }
        return config
    }
    destroy (url) {
        delete this.queue[url];
        if (!Object.keys(this.queue).length) {
            //全局loading关闭
            // Spin.hide()
        }
    }
    interceptors (instance, url) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            // 添加全局的loading...
            if (!Object.keys(this.queue).length) {
                // Spin.show() // 不建议开启，因为界面不友好
            }
            this.queue[url] = true;
            return config
        }, error => {
            return Promise.reject(error)
        });

        // 响应拦截
        instance.interceptors.response.use(res => {
            this.destroy(url);
            const { data, status } = res;
            if(data.status>0){
                if(data.code===1001){
                    // //用户登录校验失败
                    // router.push('/user/login');
                    // console.log('----- 用户登录校验失败 -----');
                    return Promise.reject(res);
                }else{
                    return {data,status};
                }
            }else{
                return { data, status };
            }
        }, error => {
            console.log('拦截器得到错误信息了...');
            console.log(error.response);
            this.destroy(url);
            let errorInfo = error.response;
            if (!errorInfo) {
                const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error));
                errorInfo = {
                    statusText,
                    status,
                    request: { responseURL: config.url }
                };
            }
            addErrorLog(errorInfo);

            router.push('/exception/500');

            return Promise.reject(error)
        })
    }
    request (options) {
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(), options);

        //因为 Content-Type = application/x-www-form-urlencoded ，为了服务端能正常获取参数，做qs的如下处理
        if(options.method==="post" && options.data){
            options.data = qs.stringify(options.data);
        }

        this.interceptors(instance, options.url);
        return instance(options)
    }
}
export default HttpRequest
